import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useAppStore } from '@/stores/app';
import type { BreadcrumbItem } from '@/lib/types/breadcrumb';

// Store

export default /*#__PURE__*/_defineComponent({
  __name: 'Breadcrumb',
  setup(__props) {

const appStore = useAppStore();
const { meta } = storeToRefs(appStore);

// Computed breadcrumbs with error handling
const crumbs = computed((): BreadcrumbItem[] => {
	try {
		const metaData = meta.value;

		// Handle null/undefined meta data
		if (!metaData || !Array.isArray(metaData)) {
			return [];
		}

		// Process data with more lenient validation
		const breadcrumbs: BreadcrumbItem[] = [];
		metaData.forEach((item, index) => {
			// More forgiving validation - just check if it has a name/title property
			if (item && typeof item === 'object') {
				const name = item.name || item.title || '';
				if (name && typeof name === 'string' && name.trim().length > 0) {
					breadcrumbs.push({
						title: name.trim(),
						redirect: item.redirect,
						index: index + 1,
					});
				}
			}
		});

		return breadcrumbs;
	} catch (error) {
		console.error('[Breadcrumb] Error processing breadcrumb data:', error);
		return [];
	}
});

return { __sfc: true,appStore, meta, crumbs }
}

})